import React from 'react'
import { useIntl } from 'react-intl'
import dayjs from 'dayjs'

import { formatPrice } from 'utils'
import { DATE_TIME_FORMATS } from 'utils/datetime'
import messages from 'views/CartV2/messages'
import AlertBadge from './assets/alert-badge.svg'
import CheckBadge from './assets/check-badge.svg'

const DeliveryDetails = ({ delivery }) => {
  const { formatMessage } = useIntl()

  const { route, logisticMinimum, orderDeadline } = delivery

  return (
    <div className="flex flex-col-reverse items-start gap-8 lg:justify-between lg:items-end lg:flex-row lg:gap-0">
      <div
        data-test-id="cart_delivery-details_selected-route"
        className="flex flex-col gap-1 pl-[41px] pb-2 lg:block lg:p-0"
      >
        <span className="text-label-13md lg:text-label-11 lg:text-grey-800">
          {`${formatMessage(messages.route)} `}
        </span>
        <span className="text-13 text-grey-800 lg:text-label-11">
          {route.name}
        </span>
      </div>
      <div className="flex gap-4 flex-row-reverse lg:flex-row">
        <div className="flex flex-col text-left lg:text-right">
          {logisticMinimum.missingNet ? (
            <span
              data-test-id="cart_delivery-details_lack-amount"
              className="text-13 text-grey-800 lg:text-label-11"
            >
              {formatMessage(messages.lackToFreeDelivery, {
                value: formatPrice(logisticMinimum.missingNet),
                styledText: text => (
                  <span className="text-blue-900">{text}</span>
                ),
              })}
            </span>
          ) : (
            <span className="text-13 lg:text-label-11">
              {formatMessage(messages.freeDelivery)}
            </span>
          )}
          <span
            data-test-id="cart_delivery-details_deadline"
            className="text-13 text-grey-800 lg:text-label-11"
          >
            {formatMessage(messages.datetimeDeadline, {
              datetime: dayjs(orderDeadline).format(
                DATE_TIME_FORMATS.FULL_DATE_TIME,
              ),
              styledText: text => <span className="text-blue-900">{text}</span>,
            })}
          </span>
        </div>
        <img
          alt=""
          src={logisticMinimum.missingNet ? AlertBadge : CheckBadge}
        />
      </div>
    </div>
  )
}

export default DeliveryDetails
